import { useMemo, useState } from "react";
import { audienceImpressions, moodFilters } from "@/mocks/fengchiData";

export default function AudienceWall() {
  const [activeMood, setActiveMood] = useState("全部");

  const list = useMemo(
    () =>
      activeMood === "全部"
        ? audienceImpressions
        : audienceImpressions.filter((item) => item.mood === activeMood),
    [activeMood],
  );

  return (
    <section id="audience" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-accent-600 text-sm font-medium">
              <i className="ri-chat-quote-line" />
              观众观后感
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              大家的真实感受，比分数更具体
            </h2>
            <p className="mt-4 text-foreground-700 text-sm md:text-base leading-relaxed">
              这里收录了来自不同观众的观后感。有人一眼就喜欢，也有人觉得节奏慢了点——
              两种声音都值得看。你可以按「好评 / 中评」筛选，看看大家的分歧到底出在哪里。
            </p>
          </div>

          <div className="flex gap-1 p-1 rounded-full bg-background-50 border border-background-200 self-start">
            {moodFilters.map((mood) => {
              const active = mood === activeMood;
              return (
                <button
                  key={mood}
                  type="button"
                  onClick={() => setActiveMood(mood)}
                  aria-pressed={active}
                  className={`px-4 py-1.5 rounded-full text-sm transition-colors cursor-pointer whitespace-nowrap ${
                    active
                      ? "bg-primary-500 text-background-50"
                      : "text-foreground-600 hover:text-primary-700"
                  }`}
                >
                  {mood}
                </button>
              );
            })}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {list.map((item) => (
            <figure
              key={item.id}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-4 md:p-5"
            >
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-800 font-heading font-bold">
                  {item.initial}
                </span>
                <div className="min-w-0">
                  <figcaption className="text-sm font-medium text-foreground-900 truncate">
                    {item.name}
                  </figcaption>
                  <p className="text-xs text-foreground-500 truncate">评价《{item.work}》</p>
                </div>
              </div>

              <div className="mt-3 flex items-center gap-2">
                <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-bold">
                  <i className="ri-star-fill" />
                  {item.score}
                </span>
                <span
                  className={`px-2 py-0.5 rounded-full text-[11px] ${
                    item.mood === "好评"
                      ? "bg-primary-100 text-primary-800"
                      : "bg-secondary-200 text-secondary-900"
                  }`}
                >
                  {item.mood}
                </span>
              </div>

              <blockquote className="mt-3 flex-1 text-sm text-foreground-700 leading-relaxed">
                {item.text}
              </blockquote>

              <div className="mt-4 pt-3 border-t border-background-200 flex items-center gap-1.5 text-xs text-foreground-400">
                <i className="ri-thumb-up-line" />
                {item.likes} 人觉得有用
              </div>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}